import React, { useState } from "react";
import {
  Divider,
  Grid,
  Input,
  Button,
  Icon,
  Menu,
  Table,
} from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
const HeaderComp = () => {
  const [dropdownView, setdropdownView] = useState("none");
  const navigate = useNavigate();
  const mobileViewNav = () => {
    if (dropdownView === "none") {
      setdropdownView("flex");
    } else {
      setdropdownView("none");
    }
  };
  const logOut = () => {
    Cookies.remove("authTokens");
    navigate("/login");
  };
  return (
    <div>
      <Grid padded className="tablet computer only">
        <Menu borderless inverted fluid fixed="top">
          <Menu.Item header as="a">
            Silver Star
          </Menu.Item>
          <Menu.Menu position="right">
            {/* <Menu.Item>
              <Input placeholder="Search..." size="small" />
            </Menu.Item> */}

            <Menu.Item onClick={() => logOut()}>Log Out</Menu.Item>
          </Menu.Menu>
        </Menu>
      </Grid>
      <Grid padded className="mobile only">
        <Menu borderless inverted fluid fixed="top">
          <Menu.Item header as="a">
            Silver Star
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item>
              <Button
                basic
                inverted
                icon
                toggle
                onClick={() => mobileViewNav()}
              >
                <Icon name="content" />
              </Button>
            </Menu.Item>
          </Menu.Menu>
          <Menu
            borderless
            fluid
            inverted
            vertical
            style={{
              display: dropdownView,
            }}
          >
            <Menu.Item onClick={() => logOut()}>Log Out</Menu.Item>
            <Divider fitted />
            {/* <Menu.Item>
              <Input placeholder="Search..." size="small" />
            </Menu.Item> */}
          </Menu>
        </Menu>
      </Grid>
    </div>
  );
};

export default HeaderComp;
